<div class="card cardWidget">
  <div class="label">
    {{ widgetInfo?.title }} ({{ widgetInfo?.tag_info[0] }})
  </div>
  <div class="value">
    {{ widgetInfo?.tagData[0]?.value }}
    <span class="unit">{{ widgetInfo?.tagData[0]?.unit }}</span>
  </div>
</div>
